export default __webpack_public_path__ + "icon_fleet_service.e3ae38d4bda16a4c9e5ee031de61ffa5.svg";